import React, { FC } from 'react';
import { Text } from '@tonic-ui/react';

type HelperTextProps = {
  value: string;
};

const HelperText: FC<HelperTextProps> = ({ value }) => {
  return (
    <Text fontSize="sm" lineHeight="sm" mt="10px">
      {value ? value : ''}
    </Text>
  );
};

export default HelperText;
